import { withTranslation } from "react-i18next";
import HomestayInfo from './HomestayInfo';

export default withTranslation()(HomestayInfo);